<template>
  <main class="home row">
    <header class="header columns is-desktop">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/home_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary">
            Solución contable y facturador <br class="is-hidden-tablet" />
            electrónico para
            <br class="is-hidden-tablet" />
            micro y pequeñas empresas
          </h2>
          <p>
            Maneja tu negocio de una manera fácil,<br class="is-hidden-touch" />
            rápida y segura. Ahorra tiempo y<br class="is-hidden-touch" />
            enfócate en lo que más te gusta hacer
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary has-text-white"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a
              class="button is-rounded bg-disabled has-text-white"
              @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <section class="section">
      <div class="section__slogan">
        <h2>Descubre un nuevo mundo</h2>
        <h1 class="color-primary">ContaFácil</h1>
        <p>
          Crea comprobantes electrónicos, controla tus gastos, gestiona el<br
            class="is-hidden-touch"
          />
          inventario y maneja la contabilidad en un solo lugar
        </p>
        <img
          class="d-block is-hidden-tablet"
          src="../assets/images/arrow.png"
          alt=""
        />
        <a
          rel="noopenner noreferer"
          class="button is-rounded bg-primary"
          href="https://app.contafacil.pe/#!/registro"
          @click="emitGlobalTriggerGtag('prueba_gratis')"
          >Prueba Gratis</a
        >
        <img
          class="d-block is-hidden-mobile"
          src="../assets/images/arrow.png"
          alt=""
        />
      </div>
      <div class="columns is-desktop section__video">
        <div class="video__player column column-50 column-offset-10">
          <!-- &nbsp; -->
          <video width="100%" height="100%" playsinline autoplay muted loop>
            <source
              src="https://contafacil-web.s3-us-west-2.amazonaws.com/Videos/video1.mp4"
              type="video/mp4"
            />
            <img src="/images/video_1.png" alt="Imagen placeholder del video" />
          </video>
        </div>
        <div class="video__text column is-two-fifths-desktop-desktop">
          <h3 class="color-title-video">
            Contafácil es la forma más fácil<br class="is-hidden-touch" />
            de emitir comprobantes de<br class="is-hidden-touch" />
            venta, llevar tu contabilidad y<br class="is-hidden-touch" />
            manejar tu negocio.
          </h3>
          <p>
            Facturador electrónico y<br class="is-hidden-touch" />
            sistema contable que busca<br class="is-hidden-touch" />
            darle al micro y pequeña<br class="is-hidden-touch" />
            empresa visibilidad del negocio<br class="is-hidden-touch" />
            en tiempo real, brindando<br class="is-hidden-touch" />
            control en la operación
          </p>
        </div>
      </div>
      <div class="columns is-desktop section__video">
        <div class="video__player column column-50">
          <!-- &nbsp; -->
          <video playsinline autoplay muted loop>
            <source
              src="https://contafacil-web.s3-us-west-2.amazonaws.com/Videos/video2.mp4"
              type="video/mp4"
            />
            <img src="/images/video_2.png" alt="Imagen placeholder del video" />
          </video>
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop-desktop-desktop"
        >
          <h3 class="color-title-video ">
            Acceso seguro en múltiples<br class="is-hidden-touch" />
            dispositivos de la forma más <br class="is-hidden-touch" />simple e
            intuitiva.
          </h3>
          <p>
            Pasa menos tiempo en papeleo y más<br class="is-hidden-touch" />
            con tus clientes. Genera ventas,<br class="is-hidden-touch" />
            organiza gastos y compras, genera<br class="is-hidden-touch" />
            reportes en solo unos segundos y<br class="is-hidden-touch" />
            desde cualquier lugar.
          </p>
        </div>
      </div>
      <div class="columns is-desktop section__video">
        <div class="video__player column column-50 column-offset-10">
          <video playsinline autoplay muted loop>
            <source
              src="https://contafacil-web.s3-us-west-2.amazonaws.com/Videos/video3.mp4"
              type="video/mp4"
            />
            <img src="/images/video_3.png" alt="Imagen placeholder del video" />
          </video>
        </div>
        <div class="video__text column is-two-fifths-desktop-desktop">
          <h3 class="color-title-video ">
            Monitorea el inventario de tu<br class="is-hidden-touch" />
            negocio desde cualquier<br class="is-hidden-touch" />
            lugar.
          </h3>
          <p>
            Gestiona en tiempo real el<br class="is-hidden-touch" />
            estado del inventario.<br class="is-hidden-touch" />
            Monitorea el costo, genera<br class="is-hidden-touch" />
            reportes y organiza las<br class="is-hidden-touch" />
            compras de acuerdo a las<br class="is-hidden-touch" />
            necesidades del negocio.
          </p>
        </div>
      </div>
      <div class="columns is-desktop section__video">
        <div class="video-mini column">
          <div class="video-mini__player">
            <video playsinline autoplay muted loop>
              <source
                src="https://contafacil-web.s3-us-west-2.amazonaws.com/Videos/video4.mp4"
                type="video/mp4"
              />
              <img
                src="/images/video_4.png"
                alt="Imagen placeholder del video"
              />
            </video>
          </div>
          <div class="video-mini__text">
            <h3 class="color-title-video ">
              Maneja tu negocio a tu manera
            </h3>
            <p>
              Conoce exáctamente tus ingresos generados, cuanto te<br
                class="is-hidden-touch"
              />
              deben tus clientes y genera reportes<br class="is-hidden-touch" />
              actualizados para compartirlos.<br class="is-hidden-touch" />
              Envía recordatorios y asegúrate de que te paguen a tiempo.
            </p>
          </div>
        </div>
        <div class="video-mini column">
          <div class="video-mini__player">
            <video playsinline autoplay muted loop>
              <source
                src="https://contafacil-web.s3-us-west-2.amazonaws.com/Videos/video5.mp4"
                type="video/mp4"
              />
              <img
                src="/images/video_5.png"
                alt="Imagen placeholder del video"
              />
            </video>
          </div>
          <div class="video-mini__text">
            <h3 class="color-title-video ">
              Conoce en qué se gasta tu dinero
            </h3>
            <p>
              Monitorea multiples gastos y compras,<br
                class="is-hidden-touch"
              />
              administra pagos y simplifica tu proceso<br
                class="is-hidden-touch"
              />
              para lograr un eficiente manejo de tu<br
                class="is-hidden-touch"
              />
              negocio.
            </p>
          </div>
        </div>
      </div>

      <div class="section__slogan section__slogan--bot">
        <img
          class="d-block is-hidden-mobile img-bottom"
          src="../assets/images/arrow.png"
          alt=""
        />
        <p class="text-multicolor my-6">
          Hoy es el <span class="color-ascend">día</span> que
          <span class="color-ascend-second">esperabas</span> para<br
            class="not-mobile"
          />
          iniciar con <span class="color-primary">nosotros</span>...
        </p>
        <img
          class="d-block is-hidden-tablet img-bottom"
          src="../assets/images/arrow.png"
          alt=""
        />
        <a
          rel="noopenner noreferer"
          class="button is-rounded bg-primary"
          href="https://app.contafacil.pe/#!/registro"
          @click="emitGlobalTriggerGtag('prueba_gratis')"
          >Prueba Gratis</a
        >
      </div>
      <div class="columns is-desktop section__video">
        <div class="video__player column">
          <video playsinline autoplay muted loop>
            <source
              src="https://contafacil-web.s3-us-west-2.amazonaws.com/Videos/video6.mp4"
              type="video/mp4"
            />
            <img src="/images/video_6.png" alt="Imagen placeholder del video" />
          </video>
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop-desktop"
        >
          <h3 class="color-title-video ">
            Te ayudamos a simplificar tu <br class="is-hidden-touch" />trabajo.
          </h3>
          <p>
            ContaFácil tiene herramientas<br class="is-hidden-touch" />
            para ayudarte a manejar <br class="is-hidden-touch" />tu negocio.
            Chat de soporte<br class="is-hidden-touch" />
            24/7, navegación guiada y <br class="is-hidden-touch" />contenido
            educativo.
          </p>
        </div>
      </div>
    </section>
    <modulos-carrousel></modulos-carrousel>
    <table-plan></table-plan>
    <!-- <blog-carrousel title /> -->
  </main>
</template>

<script>
// @ is an alias to /src
import ModulosCarrousel from "../components/ModulosCarrousel.vue";
// import BlogCarrousel from "../components/BlogCarrousel.vue";
import TablePlan from "../components/TablePlan.vue";
import { EventBus } from "@/event-bus";
export default {
  name: "Home",
  components: {
    ModulosCarrousel,
    // BlogCarrousel,
    TablePlan
  },
  data() {
    return {
      isPiPEnabled: false
    };
  },
  created() {
    if ("pictureInPictureEnabled" in document) {
      this.isPiPEnabled = true;
    }
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    start() {},
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/qpJhjnn3z9k" title="Descubre un nuevo mundo ContaFácil" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // height: calc(100vh - 75px);
  // background-image: url("../assets/images/banners/home_mobile.svg");
  // background-repeat: no-repeat;
  // background-attachment: local;
  // background-origin: border-box;
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  @include tablet() {
    background-image: none;
    background-repeat: no-repeat;
    background-attachment: local;
    background-origin: border-box;
    // padding-top: 4em;
    // height: fit-content;
    // max-height: 600px;
    &__content-wrap {
      justify-content: center;
      padding-bottom: 0;
    }
    &__content {
      background-color: transparent;
      // width: 85%;
      // padding: 1rem;
    }
  }
  @include laptop() {
    background-image: url("../assets/images/banners/home.png");
    background-repeat: no-repeat;
    background-attachment: local;
    background-origin: border-box;
    background-size: 100% 100%;
    // height: calc(100vh - 100px);
    // max-height: 500px;
    &__content-wrap {
      justify-content: flex-end;
      padding-bottom: 0;
    }
    &__content {
      background-color: transparent;
      margin-top: 0;
      height: 60%;
      // width: 85%;
      // padding: 1rem;
    }
  }
  @include desktop() {
    background-image: url("../assets/images/banners/home.png");
    background-repeat: no-repeat;
    background-attachment: local;
    background-origin: border-box;
    // height: calc(100vh - 100px);
    // max-height: 690px;
    &__content {
      background-color: transparent;
      // width: 85%;
      // padding: 1rem;
    }
  }
  @include desktop-medium() {
    background-image: url("../assets/images/banners/home.png");
    background-repeat: no-repeat;
    background-attachment: local;
    background-origin: border-box;
    // height: calc(100vh - 100px);
    // max-height: 690px;
    &__content {
      background-color: transparent;
      // width: 85%;
      // padding: 1rem;
    }
  }
  @include desktop-large() {
    // height: calc(100vh - 120px);
    // max-height: 1230px;
    &__content {
      background-color: transparent;
    }
  }
}
.section {
  padding: 1rem;
  @include tablet() {
    padding: 3rem 1rem;
  }
  &__slogan {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    margin: 0 auto 3em;
    &--bot {
      @include laptop() {
        margin-bottom: 12em;
      }
    }
    @include tablet() {
      margin-top: 3rem;
      min-height: 500px;
    }
    h1 {
      font-size: 1.75rem;
      letter-spacing: 0.05em;
      // margin: 1em 0;
      @include tablet() {
        font-size: 2.2rem;
        letter-spacing: 0.07em;
      }
      @include laptop() {
        font-size: 2.5rem;
      }
      @include desktop() {
        font-size: 3rem;
      }
      @include desktop-medium() {
        font-size: 3.5rem;
      }
      @include desktop-large() {
        font-size: 4rem;
      }
    }
    h2 {
      font-size: 1.2rem;
      letter-spacing: 0.025em;
      margin: 1em 0;
      // margin: 1em 0;
      @include tablet() {
        font-size: 2.2rem;
        letter-spacing: 0.07em;
      }
      @include laptop() {
        font-size: 2.5rem;
      }
      @include desktop() {
        font-size: 3rem;
      }
      @include desktop-medium() {
        font-size: 3.5rem;
      }
      @include desktop-large() {
        font-size: 4rem;
      }
    }
    h1,
    h2,
    p {
      font-weight: bold;
    }
    p {
      font-size: 1.05rem;
      letter-spacing: 0.025em;
      margin: 2.5em 0 1rem;
      width: 100%;
      @include tablet() {
        font-size: 1.5rem;
        width: 90%;
      }
      @include laptop() {
        margin: 2.5em 0;
        width: 80%;
        font-size: 1.3rem;
      }
      @include desktop() {
        width: 80%;
        font-size: 1.5rem;
      }
      @include desktop-medium() {
        width: 80%;
        font-size: 1.8rem;
      }
      @include desktop-large() {
        width: 65%;
        font-size: 1.8rem;
      }
    }
    .button {
      margin: 0 auto;
      border-radius: 25px;
      padding: 0.5em;
      width: fit-content;
      height: fit-content;
      font-size: 1rem;
      padding: 0.5em 1.5em;
      font-weight: bold;
      @include tablet() {
        // padding: 0.5em 2.5em;
        // max-width: 200px;
      }
      @include laptop() {
        font-size: 1.2rem;
      }
      @include desktop() {
        font-size: 1.3rem;
      }
      @include desktop-medium() {
        font-size: 1.4rem;
      }
      @include desktop-large() {
        // max-width: none;
        // width: fit-content;
        font-size: 1.8rem;
        font-weight: bold;
        // margin-top: 3em;
      }
    }
    img {
      margin: 2rem auto;
      width: 50px;
      @include laptop() {
        margin: 4rem auto;
        margin-bottom: 5rem;
      }
      @include desktop-large() {
        width: 5rem;
        margin: 5em auto;
      }
    }
    .img-bottom {
      margin: 0 auto 3em;
      @include laptop() {
        margin: 2rem auto;
        margin-bottom: 2rem;
      }
      @include desktop-large() {
        width: 4rem;
        margin: 5em auto;
      }
    }
    .text-multicolor {
      font-size: 1.5rem;
      line-height: 1.2;
      color: #444444;
      width: 100%;
      @include tablet() {
        font-size: 2.2rem;
        line-height: 1.2;
        margin-bottom: 5rem !important;
      }
      @include desktop-large() {
        font-size: 3rem;
      }
    }
  }
  &__video {
    // min-height: 500px;
    width: 100%;
    // margin: 0px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    margin: 1em 0px;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 2em 0px;
    }
    // min-height: 450px;
    // padding: 2rem;
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      color: $dark;
      margin: 2em 0;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.018em;
        font-size: 1rem;
        width: 100%;
        font-weight: bold;
        // margin: 1em auto;
      }
      p {
        width: 100%;
        font-size: 1rem;
        margin: 1em auto;
      }
      // @media (max-width: 767px) {
      //   min-width: 100%;
      //   margin: 0px;
      // }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        &--right {
          text-align: center;
          align-items: center;
        }
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.5rem;
          width: 85%;
          font-weight: bold;
        }
        p {
          width: 85%;
          font-size: 1.5rem;
        }
      }
      @include laptop() {
        text-align: left;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.2rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.2rem;
          // line-height: 1.4;
        }
      }
      @include desktop() {
        h3,
        p {
          max-width: 400px;
          margin: 1em auto;
          font-size: 1.4rem;
        }
      }
      @include desktop-medium() {
        h3,
        p {
          max-width: 450px;
          margin: 1em auto;
          font-size: 1.5rem;
        }
      }
      @include desktop-large() {
        h3,
        p {
          max-width: 70%;
          font-size: 1.6rem;
        }
      }
    }
    .video__player {
      // order: 1;
      @media (max-width: 767px) {
        margin: 0px;
        min-width: 100%;
      }
      @include tablet() {
        width: auto;
      }
      @include laptop() {
        order: 1;
      }
    }
    .video__player,
    .video-mini__player {
      // background-image: url("../assets/images/video-placeholder.png");
      // background-repeat: no-repeat;
      // background-size: 100%;
      // background-position: center;
      video {
        width: 100%;
      }
    }
    .video-mini__player {
      @include tablet() {
        min-height: 300px;
      }
    }
    .video-mini__text {
      text-align: center;
      margin: 2em auto;
      // margin-top: 1rem;
      width: 100%;
      h3 {
        letter-spacing: 0.018em;
        font-size: 1rem;
        font-weight: bold;
      }
      p {
        font-size: 1rem;
        margin: 1em auto;
      }
      @include tablet() {
        text-align: center;
        margin: 0 auto;
        margin-top: 3rem;
        width: 75%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
        }
      }
      @include laptop() {
        width: 100%;
        h3 {
          font-size: 1.2rem;
          margin-bottom: 1rem !important;
        }
        p {
          font-size: 1.2rem;
        }
      }
      @include desktop() {
        width: 100%;
        h3 {
          font-size: 1.4rem;
          margin-bottom: 1rem !important;
        }
        p {
          font-size: 1.4rem;
        }
      }
      @include desktop-medium() {
        width: 100%;
        h3 {
          font-size: 1.5rem;
          margin-bottom: 1rem !important;
        }
        p {
          font-size: 1.5rem;
        }
      }
      @include desktop-large() {
        h3,
        p {
          font-size: 1.6rem;
        }
      }
    }
    @include desktop-large() {
      margin: 5em 0;
    }
  }
}
</style>
